import React from 'react';
import { ThemeProvider } from 'styled-components';
import PageLayout from '../components/PageLayout';
import { BookingPageContent } from '../junto-frontend/components/BookingSystem';
import { solRoomTheme } from '../junto-frontend/themes/sol-room';

const PrivateClassesPage = () => {
  return (
    <ThemeProvider theme={solRoomTheme}>
      <PageLayout
        backButtonText="← Back to Class Options"
        backButtonLink="/book"
        includeFooter={true}
      >
        <BookingPageContent classType="private" />
      </PageLayout>
    </ThemeProvider>
  );
};

export default PrivateClassesPage;